import { ctor } from 'from2';
import { async } from 'regenerator-runtime';
import {
  req,
  breq,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
} from '../js/config';
import { currencyFormatter } from '../js/base';

//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};
const Initialize = async () => {
  try {
    await getPageData();
    console.log('getPageData', PageData);

    await generatePageHTML();

    await loadJavascriptNow();

    const loader = document.querySelector('.loader');
    loader.className += ' hidden'; // class "loader
  } catch (err) {
    window.location = 'index.html';
  }
};

const getPageData = async () => {
  let WebData = await getWebsiteData();
  PageData = WebData.filter((x) => x.attributes.Status === 'Available');
};

const generatePageHTML = async () => {
  document.querySelector('#copyrightYearsFooter').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  document.querySelector('#copyrightYearsMobileMenu').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  let testimonials = await googlePlaceData();

  if (testimonials != null) {
    await updateCurrentDayHours(testimonials.opening_hours);

    await phoneNumber(testimonials.formatted_phone_number);

    await address(testimonials.formatted_address);
  }
};

const googlePlaceData = async () => {
  const data = await googlePlaceDataAPI();
  console.log('🚀 ~ file: main.js ~ line 162 ~ googlePlaceData ~ data', data);
  return data;
};
const updateCurrentDayHours = async (h) => {
  let currentDay = new Date().getDay();
  currentDay == 0 ? (currentDay = 7) : currentDay;

  document.querySelector('#currentDayHours').innerHTML =
    h.weekday_text[currentDay - 1];

  let tpa = '';
  for (let i = 0; i < h.weekday_text.length; i++) {
    tpa += `<li>${h.weekday_text[i]}</li>`;
  }
  document.querySelector('#workingHours').innerHTML = tpa;
};
const phoneNumber = async (p) => {
  document.querySelector('#phoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
  document.querySelector('#footerPhoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
};

const address = async (a) => {
  document.querySelector('#address').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
  document.querySelector('#footerAddress').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
};

const generateTPL_MessageSubmitted = () => {
  var tpl = `<div class="row col-sm-12"><h3 class="text-dark">Message Sent!</h3> </div>
    <div class="row col-sm-12"><p class="lead font-weight-bold mb-4 mb-md-5">Thank you for reaching out ${
      document.querySelector('#contact_Name').value
    }. We will get back to you.</p></div>`;
  document.querySelector('#hansen_contactForm').innerHTML = tpl;
};
const submitContactForm = async (token) => {
  console.log('submit form from the contact page');
  let contactInfo = {};
  contactInfo.token = token;
  contactInfo.Name = document.querySelector('#contact_Name').value;
  contactInfo.Email = document.querySelector('#contact_Email').value;
  contactInfo.Subject = document.querySelector('#contact_Subject').value;
  contactInfo.Phone = document.querySelector('#contact_Phone').value;
  contactInfo.Message = document.querySelector('#contact_Message').value;
  breq
    .post('Contact/ContactUsAsync', JSON.stringify(contactInfo))
    .then((res) => {
      console.log(res);
      generateTPL_MessageSubmitted();
    });
};

document
  .querySelector('#hansen_contactForm')
  .addEventListener('submit', async (e) => {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LcJjOEiAAAAAIe7TA3cT8nT-xMZXKKBFtbaDrs4', {
          action: 'submit',
        })
        .then(async function (token) {
          // Add your logic to submit to  backend server.

          await submitContactForm(token);
        });
    });
  });
const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'assets/js/main.js';

  // Append to the `head` element
  document.head.appendChild(script);
};

Initialize();
